<template>
    <section class="financial-summary-view">
        <HeaderComponent :title="'Resumo Financeiro'" />

        <div class="fin-container">
            <div class="summary">
                <div class="summary-item" v-for="(field, key) in dateFields" :key="key">
                    <h1 v-text="field.name"></h1>
                    <h1 v-text="field.value"></h1>
                    <!-- <h1 v-text="geFormatedSummaryData[field.type]"></h1> -->
                </div>
                <div class="summary-item" >
                    <h1 v-text="getFinancialMedia.name"></h1>
                    <h1 v-text="getFinancialMedia.value == '--' ? getFinancialMedia.value : formatData(getFinancialMedia.value, getFinancialMedia.format)"></h1>
                </div>
            </div>
            <ExtractView @changePeriod="changePeriod" />
        </div>
    </section>
</template>

<script>
import { loadFinance, loadFinanceByPeriod } from '@/components/controllers/FinancialSummaryController'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ExtractView from '@/components/list/ExtractComponent.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    name: 'FinancialSummaryView',
    components: {
        HeaderComponent,
        ExtractView
    },
    data () {
        return {
            extrato: [],
            dateFields: []
        }
    },
    computed: {
        ...mapGetters(['getSummaryDate', 'getFinancialMedia'])
    },
    mounted () {
        loadFinance().then((res) => {
            this.dateFields = this.getSummaryDate
        })
    },
    methods: {
        formatData: function (value, format) {
            if (!value) return '--'
            if (format === 'currency') {
                return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            }
        },
        changePeriod (period) {
            let ini = period[0].value // string of format 'DD/MM/YYYY'
            let end = period[1].value // string of format 'DD/MM/YYYY'

            // convert both to moment objects of format 'DD/MM/YYYY' and log them
            ini = moment(ini, 'DD/MM/YYYY').format('DD/MM/YYYY')
            end = moment(end, 'DD/MM/YYYY').format('DD/MM/YYYY')

            loadFinanceByPeriod(ini, end)

            this.dateFields = period
        }
    }
}
</script>

<style lang="less" scoped>
.fin-container {
    .summary {
        background-color: var(--cardBackground);
        padding: 5px 10px;
        border-radius: 5px;
        margin-bottom: 30px;
    }

    .summary-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 5px 0px;

        h1 {
            font-weight: 600;
        }
    }

    .extract {
        margin: 40px 0px;
        padding-top: 30px;
        padding-bottom: 20px;
        border: 1px solid rgba(0, 0, 0, 0.18);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;

        i {
            padding-bottom: 30px;
        }

        &:active{
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);
        }
    }
}

</style>
